import { toString } from 'lodash';
import { getSlugValue } from 'utilities/getSlugValue';
import { GenerateColumnKeyParams } from './types';

const generateColumnKey = (params: GenerateColumnKeyParams) => {
  const { id = 0, name = '', prefix = '' } = params;

  return `${getSlugValue(prefix)}_${getSlugValue(name)}_${getSlugValue(toString(id))}`;
};

export default generateColumnKey;
